module.exports = __webpack_public_path__ + "img/case-logo-17.784766a1.png";